export const toFixed = (num: number = 0, fixed: number = 2): string => {
  if (isNaN(num)) {
    return '0.00';
  }
  return Number(num).toFixed(fixed);
};

/**
 * Trim all string properties in an object
 */
export const trimObject = <T extends Record<string, any>>(data: T): T => {
  const newData = { ...data } as any;
  Object.keys(data).forEach((key) => {
    if (typeof newData[key] === 'string') {
      newData[key] = newData[key].trim();
    }
  });
  return newData as T;
};

function toDisplayString(value: unknown): string {
  return typeof value === 'string' ? value : '';
}

export function formatFullName(name: unknown, lastname: unknown): string {
  const nameStr = toDisplayString(name);
  const lastnameStr = toDisplayString(lastname);
  return `${nameStr} ${lastnameStr}`.trim();
}
